import React, { useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar as CalendarIcon, Clock, CheckCircle2, ChevronLeft, ChevronRight, Activity, Package, User } from 'lucide-react';
export function ProfilePage() {
  const [selectedDate, setSelectedDate] = useState<number | null>(null);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  const [sessionType, setSessionType] = useState<string | null>(null);
  const [isBooked, setIsBooked] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  // Mock data
  const stats = {
    totalTrainings: 12,
    currentPack: '8-Pack (The Commitment)',
    sessionsRemaining: 5,
    totalSessionsInPack: 8
  };
  const availableDates = [12, 14, 15, 18, 20, 22, 25, 28];
  const availableTimes = ['10:00', '12:00', '14:00', '16:00', '18:00'];
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
    setSelectedDate(null);
    setSelectedTime(null);
    setIsBooked(false);
  };
  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
    setSelectedDate(null);
    setSelectedTime(null);
    setIsBooked(false);
  };
  const handleBook = () => {
    if (selectedDate && selectedTime && sessionType) {
      setIsBooked(true);
    }
  };
  const resetBooking = () => {
    setSelectedDate(null);
    setSelectedTime(null);
    setSessionType(null);
    setIsBooked(false);
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <main className="min-h-screen pt-32 pb-20 px-6" data-id="element-341">
      <div className="max-w-5xl mx-auto" data-id="element-342">
        {/* Header Profile Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-12 bg-dark-card border border-dark-border rounded-2xl p-8" data-id="element-343">
          <div className="w-24 h-24 rounded-full bg-dark-elevated border-2 border-accent-blue flex items-center justify-center shrink-0" data-id="element-344">
            <span className="text-3xl font-heading text-white" data-id="element-345">JD</span>
          </div>
          <div className="text-center md:text-left flex-grow" data-id="element-346">
            <h1 className="text-4xl font-heading text-white mb-2" data-id="element-347">JOHN DOE</h1>
            <p className="text-gray-400 font-body mb-4" data-id="element-348">
              Member since March 2024
            </p>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-dark-elevated rounded-lg border border-dark-border" data-id="element-349">
              <User className="w-4 h-4 text-accent-blue" data-id="element-350" />
              <span className="text-sm font-body text-gray-300" data-id="element-351">
                Active Athlete
              </span>
            </div>
          </div>
        </motion.div>

        {/* Stats Grid */}
        <motion.div variants={containerVariants} initial="hidden" animate="show" className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-352">
          <motion.div variants={itemVariants} className="bg-dark-card border border-dark-border rounded-xl p-6" data-id="element-353">
            <div className="flex items-center gap-3 mb-4" data-id="element-354">
              <div className="p-3 bg-dark-elevated rounded-lg text-accent-blue" data-id="element-355">
                <Activity className="w-6 h-6" data-id="element-356" />
              </div>
              <h3 className="text-xl font-heading text-white" data-id="element-357">
                TOTAL TRAININGS
              </h3>
            </div>
            <p className="text-5xl font-heading text-white" data-id="element-358">
              {stats.totalTrainings}
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-dark-card border border-dark-border rounded-xl p-6 flex flex-col justify-between" data-id="element-359">
            <div data-id="element-360">
              <div className="flex items-center gap-3 mb-4" data-id="element-361">
                <div className="p-3 bg-dark-elevated rounded-lg text-accent-gold" data-id="element-362">
                  <Package className="w-6 h-6" data-id="element-363" />
                </div>
                <h3 className="text-xl font-heading text-white" data-id="element-364">
                  CURRENT PACK
                </h3>
              </div>
              <p className="text-2xl font-heading text-white mb-2" data-id="element-365">
                {stats.currentPack}
              </p>
              <div className="flex items-baseline gap-2 mb-4" data-id="element-366">
                <p className="text-4xl font-heading text-white" data-id="element-367">
                  {stats.sessionsRemaining}
                </p>
                <span className="text-xl text-gray-500 font-heading" data-id="element-368">
                  / {stats.totalSessionsInPack} sessions left
                </span>
              </div>
            </div>
            <div className="w-full bg-dark-elevated rounded-full h-2.5" data-id="element-369">
              <div className="bg-accent-blue h-2.5 rounded-full" style={{
              width: `${stats.sessionsRemaining / stats.totalSessionsInPack * 100}%`
            }} data-id="element-370"></div>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-dark-card border border-dark-border rounded-xl p-6" data-id="element-371">
            <div className="flex items-center gap-3 mb-4" data-id="element-372">
              <div className="p-3 bg-dark-elevated rounded-lg text-accent-blue" data-id="element-373">
                <Clock className="w-6 h-6" data-id="element-374" />
              </div>
              <h3 className="text-xl font-heading text-white" data-id="element-375">NEXT TRAINING</h3>
            </div>
            <p className="text-2xl font-heading text-white mb-1" data-id="element-376">
              April 14, 2026
            </p>
            <p className="text-lg font-heading text-accent-blue mb-3" data-id="element-377">14:00</p>
            <p className="text-sm font-body text-gray-400" data-id="element-378">Solo Session</p>
          </motion.div>
        </motion.div>

        {/* Booking Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-card border border-dark-border rounded-2xl p-6 md:p-10" data-id="element-379">
          <div className="flex items-center gap-3 mb-8" data-id="element-380">
            <CalendarIcon className="w-8 h-8 text-accent-blue" data-id="element-381" />
            <h2 className="text-3xl font-heading text-white" data-id="element-382">
              SCHEDULE A SESSION
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-383">
            {/* Calendar */}
            <div data-id="element-384">
              <div className="flex items-center justify-between mb-6" data-id="element-385">
                <h3 className="text-xl font-heading text-white" data-id="element-386">
                  {monthNames[currentMonth]} {currentYear}
                </h3>
                <div className="flex gap-2" data-id="element-387">
                  <button onClick={handlePrevMonth} className="p-2 bg-dark-elevated rounded-lg hover:bg-dark-border transition-colors text-white" data-id="element-388">
                    <ChevronLeft className="w-5 h-5" data-id="element-389" />
                  </button>
                  <button onClick={handleNextMonth} className="p-2 bg-dark-elevated rounded-lg hover:bg-dark-border transition-colors text-white" data-id="element-390">
                    <ChevronRight className="w-5 h-5" data-id="element-391" />
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-7 gap-2 mb-2" data-id="element-392">
                {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(day => <div key={day} className="text-center text-sm font-body text-gray-500 py-2" data-id="element-393">
                    {day}
                  </div>)}
              </div>

              <div className="grid grid-cols-7 gap-2" data-id="element-394">
                {Array.from({
                length: firstDayOfMonth
              }).map((_, i) => <div key={`empty-${i}`} className="aspect-square" data-id="element-395"></div>)}
                {Array.from({
                length: daysInMonth
              }).map((_, i) => {
                const date = i + 1;
                const isAvailable = availableDates.includes(date);
                const isSelected = selectedDate === date;
                return <button key={date} disabled={!isAvailable} onClick={() => {
                  setSelectedDate(date);
                  setSelectedTime(null);
                  setSessionType(null);
                  setIsBooked(false);
                }} className={`aspect-square rounded-lg flex flex-col items-center justify-center relative transition-all duration-200 font-body text-sm
                        ${!isAvailable ? 'text-gray-600 cursor-not-allowed' : 'text-white hover:bg-dark-elevated cursor-pointer'}
                        ${isSelected ? 'bg-accent-blue text-black hover:bg-accent-blue font-bold' : 'bg-dark-primary'}
                      `} data-id="element-396">
                      {date}
                      {isAvailable && !isSelected && <div className="absolute bottom-2 w-1 h-1 rounded-full bg-accent-blue" data-id="element-397"></div>}
                    </button>;
              })}
              </div>
            </div>

            {/* Time Slots & Booking */}
            <div data-id="element-398">
              <AnimatePresence mode="wait" data-id="element-399">
                {!selectedDate ? <motion.div key="empty" initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} exit={{
                opacity: 0
              }} className="h-full flex flex-col items-center justify-center text-center p-8 border-2 border-dashed border-dark-border rounded-xl" data-id="element-400">
                    <CalendarIcon className="w-12 h-12 text-gray-600 mb-4" data-id="element-401" />
                    <p className="text-gray-400 font-body" data-id="element-402">
                      Select an available date on the calendar to view time
                      slots.
                    </p>
                  </motion.div> : isBooked ? <motion.div key="booked" initial={{
                opacity: 0,
                scale: 0.9
              }} animate={{
                opacity: 1,
                scale: 1
              }} className="h-full flex flex-col items-center justify-center text-center p-8 bg-dark-elevated border border-accent-blue rounded-xl" data-id="element-403">
                    <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} transition={{
                  type: 'spring',
                  delay: 0.2
                }} data-id="element-404">
                      <CheckCircle2 className="w-16 h-16 text-accent-blue mb-4" data-id="element-405" />
                    </motion.div>
                    <h3 className="text-2xl font-heading text-white mb-2" data-id="element-406">
                      SESSION BOOKED!
                    </h3>
                    <p className="text-gray-300 font-body mb-2" data-id="element-407">
                      You're scheduled for {monthNames[currentMonth]}{' '}
                      {selectedDate}, {currentYear} at {selectedTime}.
                    </p>
                    <p className="text-gray-400 font-body text-sm mb-6" data-id="element-408">
                      {sessionType}
                    </p>
                    <button onClick={resetBooking} className="text-accent-blue hover:text-white font-body text-sm underline transition-colors" data-id="element-409">
                      Book another session
                    </button>
                  </motion.div> : <motion.div key="times" initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -20
              }} data-id="element-410">
                    <h3 className="text-xl font-heading text-white mb-6 flex items-center gap-2" data-id="element-411">
                      <Clock className="w-5 h-5 text-accent-blue" data-id="element-412" />
                      AVAILABLE TIMES FOR{' '}
                      {monthNames[currentMonth].toUpperCase()} {selectedDate}
                    </h3>
                    <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-413">
                      {availableTimes.map(time => <button key={time} onClick={() => setSelectedTime(time)} className={`py-4 rounded-lg font-heading tracking-wider text-lg transition-all duration-200 border
                            ${selectedTime === time ? 'bg-accent-blue text-black border-accent-blue' : 'bg-dark-primary text-white border-dark-border hover:border-accent-blue'}
                          `} data-id="element-414">
                          {time}
                        </button>)}
                    </div>

                    {selectedTime && <div className="mb-8" data-id="element-415">
                        <h3 className="text-lg font-heading text-white mb-4 flex items-center gap-2" data-id="element-416">
                          <User className="w-5 h-5 text-accent-blue" data-id="element-417" />
                          SESSION TYPE
                        </h3>
                        <div className="grid grid-cols-2 gap-3" data-id="element-418">
                          {[{
                      label: '1 Person (Solo)',
                      value: '1 Person (Solo)'
                    }, {
                      label: '2 People',
                      value: '2 People'
                    }, {
                      label: '3 People',
                      value: '3 People'
                    }, {
                      label: '4 People',
                      value: '4 People'
                    }].map(type => <button key={type.value} onClick={() => setSessionType(type.value)} className={`py-3 rounded-lg font-heading tracking-wider text-base transition-all duration-200 border
                                ${sessionType === type.value ? 'bg-accent-blue text-black border-accent-blue' : 'bg-dark-primary text-white border-dark-border hover:border-accent-blue'}
                              `} data-id="element-419">
                              {type.label}
                            </button>)}
                        </div>
                      </div>}

                    <button disabled={!selectedTime || !sessionType} onClick={handleBook} className={`w-full py-4 rounded-lg font-heading tracking-wider text-xl transition-all duration-300
                        ${selectedTime && sessionType ? 'bg-accent-blue text-black hover:bg-accent-blue-hover cursor-pointer' : 'bg-dark-elevated text-gray-500 cursor-not-allowed'}
                      `} data-id="element-420">
                      CONFIRM BOOKING
                    </button>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </motion.div>
      </div>
    </main>;
}